<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <title>{{ $t('icons.new-badge-icon') }}</title>
    <circle cx="25" cy="25.07" r="25" fill="#8aaf18" />
    <path d="M17.27,30.45h-1.92l-5.04-7.42v7.42h-2.11v-10.77h2.23l4.72,7.06v-7.06h2.12v10.77Z" fill="#191c1f" />
    <path d="M26.9,19.68v1.91h-5.26v2.4h4.41v1.89h-4.41v2.67h5.26v1.91h-7.44v-10.77h7.44Z" fill="#191c1f" />
    <path
      d="M35.83,19.68l1.86,7.47,1.89-7.47h2.22l-2.88,10.77h-2.16l-1.9-7.25-1.91,7.25h-2.16l-2.89-10.77h2.29l1.88,7.47,1.86-7.47h1.91Z"
      fill="#191c1f"
    />
  </svg>
</template>

<script>
export default defineNuxtComponent({
  name: 'NewBadgeIcon',
});
</script>
